/* All intellectual property rights in the software, code and associated materials ("Software") belong to Leo Learning Limited and its licensors. All rights in the Software are expressly reserved by and to Leo Learning Limited and its licensors. Without limiting the generality of the foregoing, users of the Software are not permitted to (and agree not to) reproduce, copy or otherwise duplicate, and not to distribute, lend or otherwise transfer the Software or any part of it without the express written permission of Leo Learning Limited. Each user also undertakes not to use the Software in any way that would compromise the confidential and proprietary nature of the Software. Each user undertakes to use the Software only in accordance with the terms of the respective user license and not to resell, reproduce, sell, modify the Software in any way and acknowledges that it has no permission to so do. */ // eslint-disable-line max-len
/* global gettext, process */
import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';

import { setUserFieldCount } from 'actions/uiActions';
import Loading from 'components/Loading';
import { isPending } from 'consts/requestStates';
import { CREATE_ITEM, createItem, TENANT } from 'actions/items';
import { GET_COLLECTION, getAllCollection, OFFICES } from 'actions/collections';
import { resetRequestState } from 'actions/actions';
import CreateTenantForm from './CreateTenantForm';
import { MARKETING_CAMPAIGNS } from '../../consts/marketingCampaigns';


export class CreateTenantPage extends React.PureComponent {
  constructor(props) {
    super(props);
    if (typeof window === 'undefined') {
      global.window = {};
      global.document = {};
    }
    this.window = global.window;
    this.document = global.document;
  }

  componentWillMount() {
    this.props.resetRequestState(CREATE_ITEM, TENANT);
    if (!this.props.userHasOffice) {
      this.props.getAllCollection(OFFICES);
    }
  }

  navigateToList() {
    this.props.history.push('/tenants/');
  }

  createTenantAndNavigateToList(data) {
    const processedData = Object.assign({}, data, {
      users: data.users && data.users.filter(user => Object.keys(user).length), // Skip empty users
      url_fragment: data.url_protocol + data.url_fragment,
    });


    this.props.createTenant(processedData)
      .then(() => this.navigateToList())
      .catch(() => {
        const errors = this.document.getElementsByClassName('error');
        let didscroll = false;
        Object.keys(errors).forEach((err) => {
          if (!didscroll && errors[err].innerText !== '') {
            didscroll = true;
            const bodyRect = this.document.body.getBoundingClientRect();
            const elemRect = errors[err].getBoundingClientRect();
            const offset = elemRect.top - bodyRect.top;
            this.window.scrollTo(0, offset - 100);
          }
        });
      });
  }

  render() {
    const {
      requestState,
      isLoadingOffices,
      offices,
      userHasOffice,
      setUserFieldCount: setUserFieldCountBound,
      userCount,
    } = this.props;

    if (isLoadingOffices) {
      return <Loading />;
    }

    return (
      <div>
        <h2>{gettext('Create new client')}</h2>
        <p>{gettext('Enter your client Moodle site configuration options below.')}</p>

        <CreateTenantForm
          onSubmit={(data) => {
            // Newly created user rows may not have sendemail value due to bug
            // in react redux forms not setting default value if checked by default.
              if (Object.prototype.hasOwnProperty.call(data, 'users')) {
                if (data.users.length > 0) {
                  data.users = data.users.map((tmpuser) => {
                    if (!Object.prototype.hasOwnProperty.call(tmpuser, 'sendemail')) {
                      tmpuser.sendemail = true;
                    }
                    return tmpuser;
                  });
                }
              }
              return this.createTenantAndNavigateToList(data);
          }}
          onCancel={() => this.navigateToList()}
          requestState={requestState}
          initialValues={{
            administrator_level: '0',
            facilitator_level: '0',
            learner_level: '0',
            geo_ip_restrictions: true,
            ts_and_cs: false,
            display_company_and_employee_id: false,
            url_style: 'SUBDOMAIN',
            url_protocol: process.env.DJANGO_TENANT_DEFAULT_PROTOCOL,
            url_fragment: '',
            jhana_enabled: true,
            platform_first: true,
            [MARKETING_CAMPAIGNS.WEEKLY_NEWSLETTER_ICS]: false,
            [MARKETING_CAMPAIGNS.WEEKLY_NEWSLETTER_MANAGERS]: false,
            [MARKETING_CAMPAIGNS.LEARNER_CHALLENGES_QUARTERLY]: false,
            [MARKETING_CAMPAIGNS.NEWS_AND_UPDATES_QUARTERLY]: false,
          }}
          allowHttpProtocol={process.env.DJANGO_TENANT_DEFAULT_PROTOCOL === 'http://'}
          offices={offices}
          userHasOffice={userHasOffice}
          setUserFieldCount={setUserFieldCountBound}
          userCount={userCount}
        />
      </div>
    );
  }
}

CreateTenantPage.propTypes = {
  requestState: ImmutablePropTypes.map.isRequired,
  createTenant: PropTypes.func.isRequired,
  resetRequestState: PropTypes.func.isRequired,
  getAllCollection: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  offices: ImmutablePropTypes.list.isRequired,
  isLoadingOffices: PropTypes.bool.isRequired,
  userHasOffice: PropTypes.bool.isRequired,
  setUserFieldCount: PropTypes.func.isRequired,
  userCount: PropTypes.number.isRequired,
};

export function mapStateToProps(state) {
  return {
    userHasOffice: Boolean(state.loggedOnUser.get('office')),
    requestState: state.requestStates.getIn([CREATE_ITEM, TENANT], Map()),
    isLoadingOffices: isPending(state.requestStates.getIn([GET_COLLECTION, OFFICES], Map())),
    offices: state.collections.getIn([OFFICES, 'items'], List()),
    userCount: state.ui.getIn(['userFields', 'userCount'], 0),
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    createTenant: data => dispatch(createItem(TENANT, data)),
    resetRequestState: (actionSet, tag) => dispatch(resetRequestState(actionSet, tag)),
    getAllCollection: type => dispatch(getAllCollection(type)),
    setUserFieldCount: count => dispatch(setUserFieldCount(count)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateTenantPage));
